// com_info/ComInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * COM_INFO Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-09-02 11:34:30 using DbdbTap
 ************************************************ */

// COM_INFO & DC_INFO left joined.
const COM_INFO_LIST_PART = gql`
fragment ComInfoListPart on ComInfo {
    comId
    dcCd
    comName
    comAlias
    reprName
    compBizNo
    compCorpNo
    zipCd
    addr
    officeTel
    faxTel
    billJobType
    billJobClass
    agentName
    agentEmail
    agentTelNo
    cvoCustId
    mapUserId
    mapPassword
    useYn
    syncTime
    regDate
    regUser
    dcName
    dcTypeCd
    dcTypeName
    belongToDc
    countVehicle
}
`;



export const LIST_COM_INFO = gql`
${COM_INFO_LIST_PART}
query ListComInfo {
    comInfoList {
        ...ComInfoListPart
    }
}
`;

export const GET_COM_INFO = gql`
${COM_INFO_LIST_PART}
query GetComInfo($comId:String!) {
    comInfoItem(comId:$comId) {
        ...ComInfoListPart
    }
}
`;

export const LIST_COM_INFO_WITH_OWN_VEH_COUNT = gql`
query ListComInfoWithOwnVehCount {
    comInfoListWithOwnVehCount {
        comId
        dcCd
        comName
        dcName
        dcTypeCd
        dcTypeName
        countVehicle
    }
}
`;

// comInfoListUnsafe: [ComInfoSimple]!
export const LIST_COM_INFO_UNSAFE = gql`
query ListComInfoUnsafe {
    comInfoListUnsafe {
        comId
        comName
        dcCd
    }
}
`;

/* export const ADD_COM_INFO = gql`
${COM_INFO_LIST_PART}
mutation AddComInfo($comInfo:InputComInfoAdd!) {
	comInfoAdd(comInfo: $comInfo) {
		ok
		message
		list {
			...ComInfoListPart
		}
	}
}
`;

export const EDIT_COM_INFO = gql`
${COM_INFO_LIST_PART}
mutation EditComInfo($comInfo:InputComInfoEdit!) {
	comInfoEdit(comInfo: $comInfo) {
		ok
		message
		list {
			...ComInfoListPart
		}
	}
}
`;

export const REMOVE_COM_INFO = gql`
${COM_INFO_LIST_PART}
mutation RemoveComInfo($comInfo:InputComInfoRemove!) {
	comInfoRemove(comInfo: $comInfo) {
		ok
		message
		list {
			...ComInfoListPart
		}
	}
}
`; */

// comInfoSetUsage(comInfo: InputComInfoSetUsage!): ResponseWithComInfoList
export const SET_USAGE_COM_INFO = gql`
${COM_INFO_LIST_PART}
mutation SetUsageComInfo($comInfo:InputComInfoSetUsage!) {
	comInfoSetUsage(comInfo: $comInfo) {
		ok
		message
		list {
			...ComInfoListPart
		}
	}
}
`;

/*


type ResponseWithComInfoList {
    ok: Boolean!
    message: String
    list: [ComInfo]
}


    comInfoSetDc(comInfo: InputComInfoSetDc!): ResponseWithComInfoList
*/
export const SET_DC_COM_INFO = gql`
${COM_INFO_LIST_PART}
mutation SetDcComInfo($comInfo:InputComInfoSetDc!) {
    comInfoSetDc(comInfo: $comInfo) {
        ok
        message
        list {
            ...ComInfoListPart
        }
    }
}
`;

export function makeComInfoTree(comInfoList) {
    const dcTree = {};
    for(const comInfo of comInfoList) {
        if(!dcTree[comInfo.dcCd])
            dcTree[comInfo.dcCd] = {
                dcCd: comInfo.dcCd,
                dcName: comInfo.dcName,
                dcTypeCd: comInfo.dcTypeCd,
                dcTypeName: comInfo.dcTypeName,
                comList: []
            };
        dcTree[comInfo.dcCd].comList.push(comInfo);
    }
    const dcTypeTree = {};
    for(const dcCd of Object.keys(dcTree)) {
        const dc = dcTree[dcCd];
        if(!dcTypeTree[dc.dcTypeCd])
            dcTypeTree[dc.dcTypeCd] = {
                dcTypeCd:dc.dcTypeCd, dcTypeName:dc.dcTypeName,
                dcList:[]
            };
        dcTypeTree[dc.dcTypeCd].dcList.push(dc);
    }
    return Object.values(dcTypeTree);
}
